import React from 'react';
import { Bar } from 'react-chartjs-2';

const ClassAttendanceChart = () => {
  const data = {
    labels: ['Class 1', 'Class 2', 'Class 3', 'Class 4', 'Class 5'],
    datasets: [
      {
        label: 'Attendance (%)',
        data: [95, 88, 92, 85, 90],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'],
      },
    ],
  };

  return <Bar data={data} />;
};

export default ClassAttendanceChart;
